import {
  Button,
  Flex,
  Image,
  Text,
  Container,
  Drawer,
  DrawerBody,
  DrawerFooter,
  useDisclosure,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import logo from "../Assets/icons/promise-card-logo.svg";
import { Link } from "react-router-dom";
import { Fragment, useRef } from "react";
import { Icon } from "@chakra-ui/react";
import { FaBars } from "react-icons/fa";

function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();

  return (
    <Container py="1rem" maxW="container.xl">
      <Flex justify="space-between" align="center">
        <Flex as={Link} to="/" align="center">
          <Image src={logo} alt="Promise Card" />
          <Text size="xl" color="brand.900" fontWeight="bold" ml=".5rem">
            PromiseCard
          </Text>
        </Flex>

        <Flex display={{ base: "none", lg: "flex" }}>
          <NavItems />
        </Flex>

        <Flex display={{ base: "none", lg: "flex" }}>
          <AuthItems />
        </Flex>

        <Icon
          ref={btnRef}
          onClick={onOpen}
          display={{ md: "block", lg: "none" }}
          as={FaBars}
          w={8}
          h={8}
        />
      </Flex>

      <NavDrawer isOpen={isOpen} onClose={onClose} btnRef={btnRef} />
    </Container>
  );
}

const NavItems = () => {
  return (
    <Fragment>
      <Link to="#">
        <Text mx=".5rem">Share</Text>
      </Link>
      <Link to="/faqs">
        <Text mx=".5rem">FAQs</Text>
      </Link>
      <Link to="/about">
        <Text mx=".5rem">About Us</Text>
      </Link>
      <Link to="/contact">
        <Text mx=".5rem">Contact Us</Text>
      </Link>
    </Fragment>
  );
};

const AuthItems = () => {
  return (
    <Fragment>
      <Button bg="transparent" color="brand.900">
        Login
      </Button>
      <Button ml=".5rem" bg="brand.900" color="white">
        Signup
      </Button>
    </Fragment>
  );
};

function NavDrawer({ btnRef, onClose, isOpen }) {
  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      finalFocusRef={btnRef}
    >
      <DrawerOverlay>
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Promise Card</DrawerHeader>

          <DrawerBody>
            <NavItems />
          </DrawerBody>

          <DrawerFooter display="flex" justifyContent="center">
            <AuthItems />
          </DrawerFooter>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
}

export default Navbar;
